export const colors = {
  'red.50': '#FFF1F1',
  'red.100': '#FFDFDF',
  'red.200': '#FFC5C5',
  'red.300': '#FF9D9D',
  'red.400': '#FF6464',
  'red.500': '#FF4545',
  'red.600': '#EB3838',
  'red.700': '#C80D0D',
  'red.800': '#A50F0F',
  'red.900': '#881414',
  'red.950': '#4B0404',
  'orange.50': '#FFF5E8',
  'orange.100': '#FFEDD5',
  'orange.200': '#FED9AF',
  'orange.300': '#FDB66D',
  'orange.400': '#FB8E35',
  'orange.500': '#F96D0C',
  'orange.600': '#EA5507',
  'orange.700': '#C23D06',
  'orange.800': '#9A300C',
  'orange.900': '#7C290C',
  'orange.950': '#431205',
  'yellow.50': '#FFFCE7',
  'yellow.100': '#FFF9C1',
  'yellow.200': '#FFEF8A',
  'yellow.300': '#FFDD41',
  'yellow.400': '#FFC90D',
  'yellow.500': '#F1AE00',
  'yellow.600': '#D18500',
  'yellow.700': '#A65D02',
  'yellow.800': '#89490A',
  'yellow.900': '#743C0F',
  'yellow.950': '#441E04',
  'pink.50': '#FEF1F9',
  'pink.100': '#FEE5F5',
  'pink.200': '#FFCAEE',
  'pink.300': '#FF9FDE',
  'pink.400': '#FF63C5',
  'pink.500': '#FF1FA2',
  'pink.600': '#F01289',
  'pink.700': '#D1056D',
  'pink.800': '#AD0759',
  'pink.900': '#8F0C4D',
  'pink.950': '#58002A',
  'fuchsia.50': '#FFF0FF',
  'fuchsia.100': '#FFE0FE',
  'fuchsia.200': '#FFC8FF',
  'fuchsia.300': '#FFA0FF',
  'fuchsia.400': '#FB6CFF',
  'fuchsia.500': '#F334F9',
  'fuchsia.600': '#DA04DD',
  'fuchsia.700': '#BA00B9',
  'fuchsia.800': '#9C0095',
  'fuchsia.900': '#800077',
  'fuchsia.950': '#5A0053',
  'indigo.50': '#F5F0FF',
  'indigo.100': '#EDE4FF',
  'indigo.200': '#DECDFF',
  'indigo.300': '#C5A6FF',
  'indigo.400': '#A473FF',
  'indigo.450': '#9333EA',
  'indigo.500': '#883BFF',
  'indigo.600': '#7E14FF',
  'indigo.700': '#7000FF',
  'indigo.800': '#5F01D6',
  'indigo.900': '#4E03AF',
  'indigo.950': '#2F0077',
  'blue.50': '#E8F6FF',
  'blue.100': '#D5EDFF',
  'blue.200': '#B3DCFF',
  'blue.300': '#85C3FF',
  'blue.400': '#569BFF',
  'blue.500': '#2F72FF',
  'blue.600': '#0C44FF',
  'blue.700': '#0038FF',
  'blue.800': '#0030CD',
  'blue.900': '#082F9F',
  'blue.950': '#0A1D5C',
  'teal.50': '#ECFDFF',
  'teal.100': '#D0F8FD',
  'teal.200': '#9DF0FC',
  'teal.300': '#6DE8FC',
  'teal.400': '#13CCF0',
  'teal.500': '#0BB8DD',
  'teal.600': '#0C8AAE',
  'teal.700': '#116E8D',
  'teal.800': '#175A73',
  'teal.900': '#184B61',
  'teal.950': '#093043',
  'green.50': '#EDFFF7',
  'green.100': '#D5FFEE',
  'green.200': '#AEFFDD',
  'green.300': '#70FFC4',
  'green.400': '#2BFDA4',
  'green.500': '#00DD80',
  'green.600': '#00C06B',
  'green.700': '#009657',
  'green.800': '#067547',
  'green.900': '#07603D',
  'green.950': '#003721',
  'lime.50': '#F1FFE4',
  'lime.100': '#DFFFC4',
  'lime.200': '#C0FF90',
  'lime.300': '#A1FA66',
  'lime.400': '#5CFF00',
  'lime.500': '#50F000',
  'lime.600': '#39B800',
  'lime.700': '#2B8B00',
  'lime.800': '#256D07',
  'lime.900': '#225C0B',
  'lime.950': '#0C3400',
  'white': '#FFFFFF',
  'neutral.50': '#FCFCFC',
  'neutral.100': '#F5F5F5',
  'neutral.200': '#E7E7E7',
  'neutral.300': '#D1D1D1',
  'neutral.400': '#B0B0B0',
  'neutral.500': '#969696',
  'neutral.600': '#6C6C6C',
  'neutral.700': '#515151',
  'neutral.800': '#383838',
  'neutral.900': '#212121',
  'neutral.950': '#070707',
  'black': '#000000',
  'purple.400': '#C084FC'
}
